import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight } from "lucide-react";
import { API } from "@/config";

const media = (url) => (url?.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);
const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" }) : "");

export default function News() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/posts?limit=3`).then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  return (
    <section id="novedades" data-testid="news-section" className="py-16 sm:py-24 lg:py-32 bg-cream">
      <div className="px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto">
        <p className="text-xs sm:text-sm tracking-[0.3em] uppercase text-gold font-medium">05 · Tendencias</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight text-obsidian mt-4 max-w-xl">
          Tendencias y novedades del estudio
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          {posts.map((p, i) => (
            <Link
              key={p.id}
              to={`/novedades/${p.slug}`}
              data-testid={`news-card-${i}`}
              className="group block rounded-2xl overflow-hidden bg-creamcard border border-sand transition-[border-color,transform] duration-300 hover:border-gold/60 hover:-translate-y-1"
            >
              {p.image_url ? (
                <div className="overflow-hidden">
                  <img
                    src={media(p.image_url)}
                    alt={p.title}
                    loading="lazy"
                    className="w-full h-56 object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              ) : (
                <div className="w-full h-56 bg-rosesoft" />
              )}
              <div className="p-6">
                <p className="text-xs text-taupe">{fmt(p.published_at)}</p>
                <h3 className="font-display text-xl text-obsidian mt-2 leading-snug">{p.title}</h3>
                <p className="text-sm text-taupe mt-2 line-clamp-3">{p.excerpt}</p>
                <span className="inline-flex items-center gap-1.5 text-sm text-gold mt-4 group-hover:gap-2.5 transition-all duration-300">
                  Leer el artículo <ArrowUpRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
